<template>
  <div id="data-list-list-view" class="xxdata-list-container padTop32">
    <div class="filterWrap">
      <div style="display: flex; align-items: center">
        <v-select
          v-model="selectTJ.name"
          :options="options1"
          placeholder="请选择任务类型"
          class="item"
          style="margin-left: 10px"
        >
          <div slot="no-options">暂无选项</div>
        </v-select>
        <v-select
          v-model="selectTJ.type"
          :options="typeOptions"
          :reduce="(opt) => opt.label"
          placeholder="执行任务状态"
          class="item"
          style="margin-left: 10px"
        >
          <div slot="no-options">暂无选项</div>
        </v-select>
        <flat-pickr
          style="width: 130px; margin-top: 0 !important"
          name="date"
          v-model="rangeDate"
          class="form-control filterInput mt-5 marLeft20"
          :config="flatPickerConfig"
          placeholder="请选择时间范围"
        />
        <div class="clear-btn" data-clear></div>
      </div>
      <div>
        <vs-button class="Ann_cx" @click="dataCa()">查询</vs-button>
        <vs-button class="Ann_cz" @click="dataCz()">重置</vs-button>
      </div>
    </div>
    <!-- multiple -->
    <div class="datas">
      <gc-cmp-vs-table
        v-model="selected"
        :data="tableData"
        :pager="pager"
        noDataText="暂无数据"
      >
        <template slot="thead">
          <vs-th v-for="(column, index) in columns" :key="index">
            {{ column.name }}
          </vs-th>
        </template>
        <template slot-scope="{ data }">

          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td style="width: 50px">{{ indextr + 1 }}</vs-td>
              <vs-td>{{tr.taskType}}</vs-td>
              <vs-td>{{heTime(tr.createTime)}}</vs-td>
              <vs-td>{{ tr.taskModel }}</vs-td>
              <vs-td :class="handel_tagTime(tr.state)">{{
                handel_tag(tr.state)
              }}</vs-td>
              <vs-td>{{ tr.fileName }}</vs-td>
              <vs-td>{{ tr.errorInfo }}</vs-td>
              <vs-td class="whitespace-no-wrap span_te">
                <!-- <a href="javascript:;" @click="download(tr.fileUrl)" v-if="tr.state==2">{{
                  handel_tags(tr.state)
                }}</a>
                <a href="javascript:;" @click="cancel(tr.id)" v-if="tr.state==0">{{
                  handel_tags(tr.state)
                }}</a> -->
                <a href="javascript:;" @click="cancel(tr.id)" v-if="tr.state==0&&tr.taskType!='订单导入'&&tr.taskType!='商品上架导入'">取消文件</a>
                <a href="javascript:;" @click="download(tr.fileUrl)" v-if="tr.state==2&&tr.taskType!='订单导入'&&tr.taskType!='商品上架导入'&&tr.fileName">下载文件</a>
              </vs-td>
            </vs-tr>
          </tbody>

        </template>
      </gc-cmp-vs-table>
    </div>
    <gc-vs-pagination
      :pager="pager"
      totalName="totalCount"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></gc-vs-pagination>
  </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import vSelect from "vue-select";
import GcCmpVsInput from "@/group-cloud/components/vsInput";
import GcCmpVsTable from "@/group-cloud/components/vsTable";
import { hotScreenApi } from "@/modules/server-api/my-task";
import { Mandarin } from "flatpickr/dist/l10n/zh.js";
import moment from "moment";
import {download} from "@/url.js"

export default {
  data() {
    return {
      rangeDate: '',
      appType: "",
      options1: ["电子发票","发票申请","订单导出","发货单导出","订单导入","出库订单导出","库存导出","库存明细账导出","入库单导出","出库单导出","调拨单导出","商品上架导入","商品上架导出","商品分开上架导出"],
      selectTJ: {
        name: null, //任务状态
        type: null, //执行状态
      },
      columns: [
        {
          name: "序号",
        },
        {
          name: "任务类型",
        },
        {
          name: "任务日期",
        },
        {
          name: "所在模块",
        },
        {
          name: "任务状态",
        },
        {
          name: "执行文件",
        },
        {
          name: "报错信息",
        },
        {
          name: "操作",
        },
      ],
      tableData: [],
      pager: {
        page: 1,
        size: 20,
        totalCount: 0,
      },
      flatPickerConfig: {
        mode: "range",
        wrap: true,
        locale: Mandarin, //日期控件中文
      },
      selected: [],
      res1: ["执行中", "执行成功", "执行失败"],
      typeOptions: [], //执行状态数据
      stateName: "",
      endTim:'',//结束时间
    };
  },
  created() {
    this.getQueryData();
    this.getTableData();
    this.init();
  },
  watch: {
    appType() {
      this.getTableData();
    },
  },
  components: {
    vSelect,
    GcCmpVsInput,
    GcCmpVsTable,
    flatPickr,
  },
  methods: {
    async getQueryData() {
      this.typeOptions = this.res1.map((v) => {
        return {
          label: v,
        };
      });
    },
    init() {},
    //获取分类数据
    async getTableData(page) {
      this.$vs.loading();
      this.tableData = [];
      let pageSize = this.pager.size;
      let pageNo = page || this.pager.page;
      hotScreenApi
        .taskList({
          pageNo: pageNo,
          pageSize: pageSize,
        })
        .then((res) => {
          this.tableData = res.result.list;
          let resCount = res.result.totalCount;
          this.pager.totalCount = resCount;
          this.$vs.loading.close();
        });
    },
    //查询信息
    async dataCa(val) {
      if(this.rangeDate == null){
        this.rangeDate = ''
      }
      this.pager.page = val ? val : 1;
      if(this.rangeDate.indexOf('至') == -1 ){
        this.endTim=Date.parse(this.rangeDate.split('至')[0]);
      }else{
        this.endTim=Date.parse(this.rangeDate.split('至')[1]);
      }
      let startTi=Date.parse(this.rangeDate.split('至')[0]);
      let taskT = "";
      let taskTtate = "";
      if (this.selectTJ.name == "订单导出") {
        taskT = "order";
      }else if(this.selectTJ.name == "发票申请"){
        taskT = "invoice_generate";
      }else if(this.selectTJ.name == "电子发票"){
        taskT = "email_invoice";
      }else if(this.selectTJ.name == "发货单导出"){
        taskT = "send_order";
      }else if(this.selectTJ.name == "订单导入"){
        taskT = "order_import";
      }else if(this.selectTJ.name == "出库订单导出"){
        taskT = "out_order";
      }else if(this.selectTJ.name == "库存导出"){
        taskT = "wms_order";
      }else if(this.selectTJ.name == "库存明细账导出"){
        taskT = "wms_detail";
      }else if(this.selectTJ.name == "入库单导出"){
        taskT = "wms_in";
      }else if(this.selectTJ.name == "出库单导出"){
        taskT = "wms_out";
      }else if(this.selectTJ.name == "调拨单导出"){
        taskT = "wms_transfer";
      }
      else if(this.selectTJ.name == "商品上架导入"){
        taskT = "good_in";
      }
      else if(this.selectTJ.name == "商品上架导出"){
        taskT = "good_out";
      }
      else if(this.selectTJ.name == "商品分开上架导出"){
        taskT = "good_separate_out";
      }


      if (this.selectTJ.type == "执行失败") {
        taskTtate = 1;
      }else if (this.selectTJ.type == "执行中") {
        taskTtate = 0;
      }else if(this.selectTJ.type == "执行成功"){
        taskTtate = 2;
      }
      hotScreenApi.taskList({
          pageNo: this.pager.page,
          pageSize: this.pager.size,
          taskType: taskT,
          state: taskTtate,//状态
          startTime: startTi,//开始时间
          endTime: this.endTim,//结束时间
        })
        .then((res) => {
          this.tableData = res.result.list;
          let resCount = res.result.totalCount;
          this.pager.totalCount = resCount;
          this.$vs.loading.close();
        });
    },
    //重置信息
    dataCz() {
      this.selectTJ = {};
      this.rangeDate = '';
      this.getTableData(1);
      this.pager.page = 1;
    },
    //更改每页条数
    handleSizeChange(val) {
      this.pager.size = val;
      this.dataCa();
    },
    handleCurrentChange(val) {
      this.pager.page = val;
      this.dataCa(val);
    },
    handel_tag(data) {
      switch (data) {
        case 0:
          return "执行中";
        case 2:
          return "执行成功";
        case 1:
          return "执行失败";
      }
    },
    handel_tags(data) {
      switch (data) {
        case 1:
          return " ";
        case 2:
          return "下载文件";
        case 0:
          return "取消文件";
      }
    },
    handel_tagTime(data) {
      switch (data) {
        case 1:
          return "state1";
        case 2:
          return "state2";
        case 0:
          return "state3";
      }
    },
    heTime(time){//时间戳转化
      return moment(time).format("YYYY-MM-DD HH:mm:ss");
    },
    //下载文件
    download(url) {
      console.log(url,download)
      window.open( download + "download-excel/" + url);
    },
    //取消下载文件
    cancel(id){
      hotScreenApi.cancelApi({id: id,}).then((res) => {
        this.dataCz();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/modules/commodity-sys/commodity.scss";
#data-list-list-view {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  .categoryHead {
    background-color: #f3f2f7;
    height: 38px;
    line-height: 38px;
    .vs-col {
      color: #5e5873;
    }
  }
  .optCol {
    display: flex;
    justify-content: flex-end;
    padding-right: 18px;
  }
  .Ann_cx {
    margin-right: 20px;
  }
  .Ann_cz {
    background-color: #fff !important;
    color: #000;
    border: 1px solid #333;
  }
  .span_te {
    color: rgba(var(--vs-primary), 1);
  }

  .state1 {
    color: red;
  }
  .state2 {
    color: green;
  }
  .state3 {
    color: #e6a23c;
  }
  .datas{
    height: 520px;
    overflow: auto;
  }
}
</style>
